export const FIELDS = {
  RADIO: { key: 'radio', optionsKey: 'radioOptions' },
  SELECT: { key: 'select', optionsKey: 'selectOptions' },
  SELECT_MULTI: { key: 'select_multi', optionsKey: 'multiSelectOptions' },
  IMAGE: { key: 'image' },
}

export const fieldTypeOptions = [
  { value: 'text', label: 'Text' },
  { value: 'textarea', label: 'Text Area' },
  { value: 'phone', label: 'Phone' },
  { value: 'radio', label: 'Radio' },
  { value: 'select', label: 'Select' },
  { value: 'select_multi', label: 'Multiple Select' },
]

export const toggles = [
  {
    key: 'required',
    onText: 'Required',
  },
  {
    key: 'settings.showOnMyTickets',
    onText: 'Show on My Ticket',
  },
  {
    key: 'settings.showOnPdf',
    onText: 'Show on PDF',
  },
  {
    key: 'settings.showOnScan',
    onText: 'Show on Scan',
  },
  {
    key: 'settings.allowUpdate',
    onText: 'Allow Update',
  },
]
